import styled from '@emotion/styled';

import { HeaderElementProps } from '../columns/types';

export const GridHeaderElement = styled.div<HeaderElementProps>`
  cursor: ${(props) => (props.is_resizing ? 'col-resize' : 'pointer')};
  border-color: ${(props) => props.theme.header.border_color} !important;
  background: ${(props) => props.theme.header.background};
  ${(props) =>
    props.sort_field &&
    `
        &:hover {
         color: ${props.theme.color.hover};
        }
    `}
`;
